// ManufacturingAccountsReducer.js — Manufacturing tab > Accounts page.
// Wired into rootReducer.js as `manufacturingAccounts`.

const initialState = {
  purchaseLedger: { entries: [], totals: {}, bySupplier: [] },
  productionSummary: { batches: [], totals: {} },
  loading: false,
  error: null
};

const ManufacturingAccountsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_MFG_PURCHASE_LEDGER_REQUEST':
    case 'FETCH_MFG_PRODUCTION_SUMMARY_REQUEST':
      return { ...state, loading: true, error: null };

    case 'FETCH_MFG_PURCHASE_LEDGER_SUCCESS':
      return { ...state, loading: false, purchaseLedger: action.payload };
    case 'FETCH_MFG_PRODUCTION_SUMMARY_SUCCESS':
      return { ...state, loading: false, productionSummary: action.payload };

    case 'FETCH_MFG_PURCHASE_LEDGER_FAILURE':
    case 'FETCH_MFG_PRODUCTION_SUMMARY_FAILURE':
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default ManufacturingAccountsReducer;
